<template>
  <section class="dashboard-card fouling-rate-graph">
    <h3>Fouling Rate Graph</h3>

    <div class="placeholder-chart">
      Existing fouling rate graph
    </div>
  </section>
</template>

<script>
export default {
  name: "FoulingRateGraph"
};
</script>

<style scoped>
.dashboard-card {
  background: var(--color-primary);
  border: 1px solid #dbe3ef;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.dashboard-card h3 {
  margin: 0 0 14px;
  color: #0f172a;
  font-size: 18px;
}

.placeholder-chart {
  height: 220px;
  border-radius: 12px;
  background: linear-gradient(135deg, #e0f2fe, #f8fafc);
  border: 1px dashed #38bdf8;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0369a1;
  font-weight: 600;
}
</style>
